import * as React from "react";
import {useEffect, useState} from "react";
import {
    Create,
    Datagrid,
    Edit,
    EditButton,
    Error,
    FileField,
    FileInput,
    ImageField,
    ImageInput,
    List,
    Loading,
    ReferenceInput,
    SelectInput, Button as ButtonRA,
    ShowButton,
    CreateButton,
    TabbedForm,
    ExportButton,
    TopToolbar,
    Tab,
    TabbedShowLayout,
    DeleteWithConfirmButton,
    TextField,
    TextInput,
    SaveButton,
    downloadCSV,
    useQuery,
    FormTab, SelectField, useGetIdentity,
} from 'react-admin';
import {Button} from "@material-ui/core";
import RichTextInput from "ra-input-rich-text";
import Empty from "../empty";
import PublishIcon from '@material-ui/icons/Publish';
import DeleteIcon from '@material-ui/icons/Delete';
import jsonExport from 'jsonexport/dist';
import { BarLoader,DoubleOrbit, SlidingPebbles }
    from 'react-spinner-animated';

import 'react-spinner-animated/dist/index.css'

// Import the main component
import {ProgressBar, Viewer} from '@react-pdf-viewer/core';
import {searchPlugin} from '@react-pdf-viewer/search';
import {zoomPlugin} from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import {pageNavigationPlugin} from '@react-pdf-viewer/page-navigation';

// Import styles
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
import {printPlugin} from "@react-pdf-viewer/print";
import '@react-pdf-viewer/print/lib/styles/index.css';
import '@react-pdf-viewer/search/lib/styles/index.css';
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import axios from "axios";
import {SERVER_URL} from "../../utils";

const postFilters = [
    <TextInput source="q" label="Cerca" alwaysOn/>,
];

const exporter = products => {
    console.table(products);
    const productsToExport = products.map(item => {
        const {
            dataSheet,
            img,
            userManual,
            installerManual,
            visible,
            manufacturerCode,
            productTypeCode,
            createdBy,
            ...productToExport
        } = item;
        productToExport.manufacturer = {
            id: manufacturerCode.id,
            name: manufacturerCode.name,
            websiteUrl: manufacturerCode.webSiteUrl,
            headquarterAddress: manufacturerCode.headquarterAddress,
        };
        productToExport.productType = {
            id: productTypeCode.id,
            description: productTypeCode.description,
            productName: productTypeCode.productName,
        };
        return productToExport;
    });
    jsonExport(productsToExport, (err, csv) => {
        downloadCSV(csv, 'products');
    });
    console.table(productsToExport);
}

const ToolbarButtons = (props) => (
    <TopToolbar>
        <CreateButton disabled={props.identity.admin} label={"Nuovo"}/>
        <ExportButton label={"Esporta"}/>
        {/* Add your custom actions */}
        <ButtonRA
            href={"#/import-csv"}
            label="Importa"
            disabled={props.identity.admin}
        >
            <PublishIcon/>
        </ButtonRA>
    </TopToolbar>
)

export const ProductList = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;
    return (
        <List {...props} perPage={25} filters={postFilters} empty={<Empty/>} actions={<ToolbarButtons identity={identity}/>}
              exporter={exporter}>
            <Datagrid rowClick="edit">
                <TextField source="id" label="ID"/>
                <TextField source="productName" label="Nome del prodotto"/>
                <ImageField source="img" label="Immagine del prodotto" textAlign="center"/>
                <ShowButton label="Manuali"/>
                <EditButton label="Modifica"/>
                <DeleteWithConfirmButton label={"Elimina"}
                                         disabled={identity.admin}
                                         confirmContent="Non sarai in grado di annullare l'operazione. Sei sicuro?"/>
            </Datagrid>
        </List>
    );
}
const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton disabled={props.identity.admin} label={"Salva"} submitOnEnter={false}
                    redirect={props.redirect} {...props}/>
        <Button href={"#/product"}>Annulla</Button>
    </Toolbar>
);

export const ProductCreate = (props) => {
    const {identity, loading} = useGetIdentity();
    const [status, setStatus] = useState("");
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;

    return (
        <Create {...props}>
            <TabbedForm toolbar={<PostEditToolbar identity={identity}/>}>
                <FormTab label="Informazioni Generali">
                    <TextInput label="ID" source="id"/>
                    <TextInput source="productName" label="Nome del prodotto"/>
                    <RichTextInput source="description" label="Descrizione"/>
                </FormTab>
                <FormTab label="Informazioni Tecniche">
                    <ReferenceInput source="manufacturerCode.id" reference="manufacturer" label="Produttore">
                        <SelectInput optionText="name" optionValue="id"/>
                    </ReferenceInput>
                    <ReferenceInput source="productTypeCode.id" reference="product_type" label="Tipologia di Prodotto">
                        <SelectInput optionText="productName" optionValue="id"/>
                    </ReferenceInput>
                    <ReferenceInput source="defaultWarranty.id" reference="warranty" label="Garanzia di Default">
                        <SelectInput optionText="description" optionValue="id"/>
                    </ReferenceInput>
                </FormTab>
                <FormTab label="Documenti">
                    <FileInput source="files.userManual" label="Manuale Utente" accept="application/pdf"
                               placeholder="Trascina o seleziona un file per aggiungere un pdf.">
                        <FileField source="src" title="userManual"/>
                    </FileInput>
                    <FileInput source="files.installerManual" label="Manuale Installatore" accept="application/pdf"
                               placeholder="Trascina o seleziona un file per aggiungere un pdf.">
                        <FileField source="src" title="installerManual"/>
                    </FileInput>
                    <FileInput source="files.document" label="Documento" accept="application/pdf"
                               placeholder="Trascina o seleziona un file per aggiungere un pdf.">
                        <FileField source="src" title="document"/>
                    </FileInput>
                </FormTab>
                <FormTab label="Immagini">
                    <ImageField source="img" title={"Immagine"} label="Immagine del prodotto"/>
                    <ButtonRA style={{
                        color: "red"
                    }} label={"Rimuovi Immagine"} icon={<DeleteIcon/>} onClick={async () => {
                        setStatus("Elaborazione della richiesta in corso...");
                        const res = await axios.post(SERVER_URL + "/api/v1/product/remove-image/" + props.id, {
                            withCredentials: true
                        })
                        setStatus(res.data);
                    }}/>
                    <p>{status}</p>
                    <ImageInput source="pictures" label="Immagine del prodotto" accept="image/*" multiple={false}
                                placeholder={<p>Inserisci immagine</p>}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                </FormTab>
            </TabbedForm>
        </Create>
    );
}

export const ProductEdit = (props) => {
    const [status, setStatus] = useState("");
    const [manualStatus, setManualStatus] = useState("");
    const {identity, loading} = useGetIdentity();
    const [manuals, setManuals] = useState({
        installer: null,
        user: null,
        document: null
    });

    useEffect(() => {
        axios.get(SERVER_URL + "/api/v1/product/manuals/" + props.id).then(res => {
            setManuals(res.data)
        });
    }, []);

    if (loading) return <BarLoader text={"Caricamento..."}
                                     center={true}/>;
    return (
        <Edit {...props}>
            <TabbedForm toolbar={<PostEditToolbar identity={identity}/>}>
                <FormTab label="Informazioni Generali">
                    <TextInput disabled label="ID" source="id"/>
                    <TextInput disabled={identity.admin} source="productName" label="Nome del prodotto"/>
                    <RichTextInput disabled={identity.admin} source="description" label="Descrizione"/>
                </FormTab>
                <FormTab label="Informazioni Tecniche">
                    <ReferenceInput disabled={identity.admin} source="manufacturerCode.id" reference="manufacturer"
                                    label="Produttore">
                        <SelectInput optionText="name" optionValue="id"/>
                    </ReferenceInput>
                    <ReferenceInput disabled={identity.admin} source="productTypeCode.id" reference="product_type"
                                    label="Tipologia di Prodotto">
                        <SelectInput optionText="productName" optionValue="id"/>
                    </ReferenceInput>
                    <ReferenceInput disabled={identity.admin} source="defaultWarranty.id" reference="warranty"
                                    label="Garanzia di Default">
                        <SelectInput optionText="description" optionValue="id"/>
                    </ReferenceInput>
                </FormTab>
                <FormTab label="Documenti">
                    <p>{manualStatus}</p>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                            <FileInput source="files.userManual" label="Manuale Utente" accept="application/pdf"
                                       placeholder={manuals.user ? "Trascina o selezione un file per modificare il pdf." : "Trascina o seleziona un file per aggiungere un pdf."}>
                                <FileField source="src" title="userManual"/>
                            </FileInput>
                        </Grid>
                        {manuals.user && <Grid item xs={4}>
                            <div>
                                {manuals.user && <span style={{
                                    textDecoration: "underline",
                                    color: "blue"
                                }}>{manuals.user}</span>}
                                <ButtonRA disabled={identity.admin} style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    marginLeft: "5%"
                                }} label={"Rimuovi"} icon={<DeleteIcon/>} onClick={async () => {
                                    setManualStatus("Elaborazione della richiesta in corso...");
                                    const res = await axios.post(SERVER_URL + "/api/v1/product/remove-manual/user/" + props.id, {
                                        withCredentials: true
                                    });
                                    setManualStatus("");
                                    if (res.data === "Manuale eliminato")
                                        setManuals({...manuals, user: null});
                                    alert(res.data);
                                }}/>
                            </div>
                        </Grid>}
                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                            <FileInput source="files.installerManual" label="Manuale Installatore"
                                       accept="application/pdf"
                                       placeholder="Trascina o seleziona un file per aggiungere un pdf.">
                                <FileField source="src" title="installerManual"/>
                            </FileInput>
                        </Grid>
                        {manuals.installer && <Grid item xs={4}>
                            <div>
                                {manuals.installer && <span style={{
                                    textDecoration: "underline",
                                    color: "blue"
                                }}>{manuals.installer}</span>}
                                <ButtonRA disabled={identity.admin} style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    marginLeft: "5%"
                                }} label={"Rimuovi"} icon={<DeleteIcon/>} onClick={async () => {
                                    setManualStatus("Elaborazione della richiesta in corso...");
                                    const res = await axios.post(SERVER_URL + "/api/v1/product/remove-manual/installer/" + props.id, {
                                        withCredentials: true
                                    });
                                    setManualStatus("");
                                    if (res.data === "Manuale eliminato")
                                        setManuals({...manuals, installer: null});
                                    alert(res.data);
                                }}/>
                            </div>
                        </Grid>}
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={8}>

                                <FileInput source="files.document" label="Documento" accept="application/pdf"
                                           placeholder="Trascina o seleziona un file per aggiungere un pdf.">
                                    <FileField source="src" title="document"/>
                                </FileInput>
                            </Grid>
                            {manuals.document && <Grid item xs={4}>
                                <div>
                                    {manuals.document && <span style={{
                                        textDecoration: "underline",
                                        color: "blue"
                                    }}>{manuals.document}</span>}
                                    <ButtonRA disabled={identity.admin} style={{
                                        backgroundColor: "red",
                                        color: "white",
                                        marginLeft: "5%"
                                    }} label={"Rimuovi"} icon={<DeleteIcon/>} onClick={async () => {
                                        setManualStatus("Elaborazione della richiesta in corso...");
                                        const res = await axios.post(SERVER_URL + "/api/v1/product/remove-manual/document/" + props.id, {
                                            withCredentials: true
                                        })
                                        setManualStatus("");
                                        if (res.data === "Manuale eliminato")
                                            setManuals({...manuals, document: null});
                                        alert(res.data);
                                    }}/>
                                </div>
                            </Grid>}
                        </Grid>
                    </Grid>
                </FormTab>
                <FormTab label="Immagini">
                    <ImageField source="img" title={"Immagine"} label="Immagine del prodotto"/>
                    <ButtonRA disabled={identity.admin} style={{
                        color: "red"
                    }} label={"Rimuovi Immagine"} icon={<DeleteIcon/>} onClick={async () => {
                        setStatus("Elaborazione della richiesta in corso...");
                        const res = await axios.post(SERVER_URL + "/api/v1/product/remove-image/" + props.id, {
                            withCredentials: true
                        })
                        setStatus(res.data);
                    }}/>
                    <p>{status}</p>
                    {!identity.admin &&
                        <ImageInput source="pictures" label="Immagine del prodotto" accept="image/*" multiple={false}
                                    placeholder={<p>Inserisci immagine</p>}>
                            <ImageField source="src" title="title"/>
                        </ImageInput>}
                </FormTab>
            </TabbedForm>
        </Edit>
    );
}

export const ShowProduct = (
    {
        id
    }
) => {
    const {data, loading, error} = useQuery({
        type: 'getOne',
        resource: 'product',
        payload: {id}
    });

    const [pageNavigationPluginInstance] = useState(pageNavigationPlugin());
    const [printPluginInstance] = useState(printPlugin());
    const [searchPluginInstance] = useState(searchPlugin());
    const [zoomPluginInstance] = useState(zoomPlugin());

    if (loading) return <Loading/>;
    if (error) return <Error error={error}/>;
    if (!data) return null;

    const blobInstallerManual = base64toBlob(data.installerManual);
    const blobUserManual = base64toBlob(data.userManual);
    const blobDocument = base64toBlob(data.dataSheet);
    if (!blobUserManual && !blobInstallerManual && !blobDocument) return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{
                marginTop: "10%"
            }}
        >
            <Grid item xs={6}>
                <Button variant="text" disabled color="error" style={{
                    color: "red"
                }}>È stato riscontrato un errore nella decodifica dei manuali!</Button>
            </Grid>
            <Grid item xs={6}>
                <Button href={"#/product"}>Indietro</Button>
            </Grid>
        </Grid>)

    let urlInstallerManual, urlUserManual, urlDocument;
    if (blobInstallerManual)
        urlInstallerManual = URL.createObjectURL(blobInstallerManual);
    if (blobUserManual)
        urlUserManual = URL.createObjectURL(blobUserManual);
    if (blobDocument)
        urlDocument = URL.createObjectURL(blobDocument);
    const {GoToFirstPage, GoToLastPage, GoToNextPage, GoToPreviousPage} = pageNavigationPluginInstance;
    const {Print} = printPluginInstance;
    const {ShowSearchPopoverButton} = searchPluginInstance;
    const {ZoomInButton, ZoomOutButton, ZoomPopover} = zoomPluginInstance;

    return (
        <TabbedShowLayout>
            {blobUserManual && <Tab label="Manuale Utente" key={"Manuale Utente"}>
                <div
                    style={{
                        border: '1px solid rgba(0, 0, 0, 0.3)',
                        height: window.innerHeight,
                    }}
                >
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <ShowSearchPopoverButton/>
                        <ZoomInButton/>
                        <ZoomOutButton/>
                        <ZoomPopover/>
                        <GoToFirstPage/>
                        <GoToLastPage/>
                        <GoToNextPage/>
                        <GoToPreviousPage/>
                        <Print/>
                    </div>
                    <Viewer fileUrl={urlUserManual}
                            plugins={[pageNavigationPluginInstance, printPluginInstance, searchPluginInstance, zoomPluginInstance]}
                            renderLoader={(percentages) => (
                                <div style={{width: '240px'}}>
                                    <ProgressBar progress={Math.round(percentages)}/>
                                </div>
                            )}
                    />
                </div>
            </Tab>}
            {blobInstallerManual && <Tab label="Manuale Installatore" key={"Manuale Installatore"}>
                <div
                    style={{
                        border: '1px solid rgba(0, 0, 0, 0.3)',
                        height: window.innerHeight,
                    }}
                >
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <ShowSearchPopoverButton/>
                        <ZoomInButton/>
                        <ZoomOutButton/>
                        <ZoomPopover/>
                        <GoToFirstPage/>
                        <GoToLastPage/>
                        <GoToNextPage/>
                        <GoToPreviousPage/>
                        <Print/>
                    </div>
                    <Viewer fileUrl={urlInstallerManual}
                            plugins={[pageNavigationPluginInstance, printPluginInstance, searchPluginInstance, zoomPluginInstance]}
                            renderLoader={(percentages) => (
                                <div style={{width: '240px'}}>
                                    <ProgressBar progress={Math.round(percentages)}/>
                                </div>
                            )}
                    />
                </div>
            </Tab>}
            {blobDocument && <Tab label="Documento" key={"Documento"}>
                <div
                    style={{
                        border: '1px solid rgba(0, 0, 0, 0.3)',
                        height: window.innerHeight,
                    }}
                >
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <ShowSearchPopoverButton/>
                        <ZoomInButton/>
                        <ZoomOutButton/>
                        <ZoomPopover/>
                        <GoToFirstPage/>
                        <GoToLastPage/>
                        <GoToNextPage/>
                        <GoToPreviousPage/>
                        <Print/>
                    </div>
                    <Viewer fileUrl={urlDocument}
                            plugins={[pageNavigationPluginInstance, printPluginInstance, searchPluginInstance, zoomPluginInstance]}
                            renderLoader={(percentages) => (
                                <div style={{width: '240px'}}>
                                    <ProgressBar progress={Math.round(percentages)}/>
                                </div>
                            )}
                    />
                </div>
            </Tab>}
        </TabbedShowLayout>
    )
}

const base64toBlob = (data) => {
        // Cut the prefix `data:application/pdf;base64` from the raw base 64
        if (!data) return null;
        const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], {type: 'application/pdf'});
    }
;

